export const VueLogger = {
  install(Vue, options) {
    Vue.prototype.$log = Vue.$log = (...args) => console.log(...args);
    Vue.prototype.$warn = Vue.$warn = (...args) => console.warn(...args);
    Vue.prototype.$info = Vue.$info = (...args) => console.info(...args);
    Vue.prototype.$error = Vue.$error = (...args) => console.error(...args);
  }
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/loggerPlugin.ts